import { SET_THEME } from "./themeActions";
import { HYDRATE_STATE } from "./indexActions";
import goLogo from "../css/images/logos/Go.png";
import { nucleus } from "../NucleusTheme";

const THEME_SERVICE_NUCLEUS_THEME_NAME = "Nucleus Theme";

export const theme = (state = { selectedTheme: nucleus, isThemeReady: false }, action) => {
    switch (action.type) {
        case SET_THEME: {
            const logo =
                action.theme.logo && action.theme.themeName !== THEME_SERVICE_NUCLEUS_THEME_NAME
                    ? action.theme.logo
                    : goLogo;
            const newTheme = {
                ...nucleus,
                primary: action.theme.highlightColour || nucleus.primary,
                logo,
                isBranded: logo === action.theme.logo
            };
            return { selectedTheme: newTheme, isThemeReady: true };
        }

        case HYDRATE_STATE:
            return { ...state, ...action.newState.theme };

        default:
            return state;
    }
};
